import { FACEBOOK_BASE_URL, K_LOCAL_STORAGE_PAGE_FEED } from '../../constants';
const axios = require('axios');
const moment = require('moment');

// Function to get comments with pagination (Next, Previous, and Limit)
export async function getCommentsWithPagination({pageId, postId, accessToken, limit}) {
    // get comment from local storage by pageId, postId
    const keyLocal = K_LOCAL_STORAGE_PAGE_FEED(pageId);
    let commentsLocalStorage = JSON.parse(localStorage.getItem(keyLocal)) || [];
    const commentsLocal = commentsLocalStorage.find(post => post.id === postId);
    if (commentsLocal) {
        if (commentsLocal.comments && Date.now() < commentsLocal.expire) {
            console.log("post comments data from local storage");
            return commentsLocal.comments;
        }
    }

    let comments = [];
    // let url = `https://graph.facebook.com/v19.0/${postId}/comments`;
    let url = `${FACEBOOK_BASE_URL}${pageId}_${postId}/comments`;
    let afterCursor = null;
    const sevenDaysAgo = moment().subtract(7, 'days'); // 7 days ago timestamp
    const now = moment(); // Current time

    while (true) {
        try {
            const response = await axios.get(url, {
                params: {
                    access_token: accessToken,
                    fields: 'id,message,created_time,from{id,name,picture},can_reply_privately',
                    limit: limit, // Fetch max 100 comments per request
                    order: 'reverse_chronological', // Newest first
                    after: afterCursor // Pagination cursor
                }
            });

            if (!response.data.data.length) break; // No more comments

            // Filter comments within the last 7 days until now
            const recentComments = response.data.data.filter(comment => comment.can_reply_privately === true &&
                moment(comment.created_time).isBetween(sevenDaysAgo, now, null, '[]') // Inclusive range
            );

            comments.push(...recentComments);

            // Get next page cursor
            afterCursor = response.data.paging?.cursors?.after;

            // Stop if no next page or if the last fetched comment is older than 7 days
            if (!afterCursor || moment(response.data.data[response.data.data.length - 1].created_time).isBefore(sevenDaysAgo)) {
                break;
            }
        } catch (error) {
            console.error('Error fetching comments:', error.response?.data || error.message);
            break;
        }
    }

    // Store comments in local storage and expire in 10 minutes
    // delete comment by postId out commentsLocalStorage
    commentsLocalStorage = commentsLocalStorage.filter(comment => comment.id !== postId);
    commentsLocalStorage.push({id: postId, comments: comments, expire: Date.now() +1 * 60 * 1000});
    localStorage.setItem(keyLocal, JSON.stringify(commentsLocalStorage));
    console.log("post comments data from Facebook");
    return comments;
}
// export async function getCommentsWithPagination({pageId, postId, accessToken, limit = 10, afterCursor = null, beforeCursor = null}) {
//     let url = `${FACEBOOK_BASE_URL}${pageId}_${postId}/comments`;
//     // console.log({url, pageId, postId, accessToken, limit, afterCursor, beforeCursor});
//     if (pageId || postId || accessToken, limit <= 0) {
//         return `INVALID_DATA_REQUEST`;
//     }

//     try {
//         const response = await axios.get(url, {
//             params: {
//                 access_token: accessToken,
//                 fields: 'id,message,created_time,from{id,name,picture},can_reply_privately', // You can add more fields if needed, parent is for check amount reply
//                 limit: limit, // Number of comments per page
//                 after: afterCursor, // Cursor for the next page
//                 before: beforeCursor, // Cursor for the previous page
//                 order: 'reverse_chronological' // Sort by most recent comments
//             }
//         });

//         console.log('Comments:', response.data.data);

//         // Print pagination info
//         // console.log('Pagination Info:');
//         // if (response.data.paging) {
//         //     if (response.data.paging.next) {
//         //         console.log('Next Page URL:', response.data.paging.next);
//         //     }
//         //     if (response.data.paging.previous) {
//         //         console.log('Previous Page URL:', response.data.paging.previous);
//         //     }
//         //     if (response.data.paging.cursors) {
//         //         console.log('Cursors:', response.data.paging.cursors);
//         //     }
//         // }

//         // Get current timestamp and calculate 7 days ago
//         const sevenDaysAgo = moment().subtract(7, 'days'); // 7 days ago timestamp
//         const now = moment(); // Current time
//         console.log("res", response.data);
//         // Filter comments within the last 7 days until now
//         const recentComments = response.data.data.filter(comment =>
//             moment(comment.created_time).isBetween(sevenDaysAgo, now, null, '[]') // Inclusive range
//         );
//         console.log('Recent Comments:', recentComments);

//         return recentComments;
//     } catch (error) {
//         console.error('Error fetching comments:', error.response ? error.response.data : error.message);
//         return null;
//     }
// }